import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns/format';

import { useTableDataQuery } from '@/modules/common';
import { PaginatedTable, TableItemStatus } from '@/modules/common/components';

import { Model } from '../types';

interface ModelsTableProps {
  onClick: (item: Model) => void;
}

const columns: ColumnDef<Model>[] = [
  {
    accessorKey: 'name',
    header: 'Model Name',
  },
  {
    accessorKey: 'type',
    header: 'Model Type',
    cell: ({ row }) => row.original.type.value,
  },
  {
    accessorKey: 'color',
    header: 'Color',
    cell: ({ row }) => row.original.color.value,
  },
  {
    accessorKey: 'gender',
    header: 'Gender',
    cell: ({ row }) => row.original.gender.value,
  },
  {
    accessorKey: 'status',
    header: 'Status',
    size: 200,
    cell: ({ row }) => <TableItemStatus status={row.getValue('status')} />,
  },
  {
    size: 130,
    accessorKey: 'updatedAt',
    header: 'Upload Date',
    cell: ({ row }) =>
      format(new Date(row.getValue('updatedAt')), 'yyyy-MM-dd'),
  },
];

export function ModelsTable({ onClick }: ModelsTableProps) {
  const { data, isFetching, refetch, ...tableProps } = useTableDataQuery<Model>(
    {
      url: '/v2/models',
      persistState: true,
    }
  );

  return (
    <PaginatedTable<Model>
      data={data}
      onClick={onClick}
      columns={columns}
      searchable
      searchPlaceholder="Search by model name"
      emptyDescription="No models uploaded yet"
      isLoading={isFetching}
      {...tableProps}
    />
  );
}
